<template>
  <page-container @window-return="windowReturn">
    <search-bar :items="[
      { key: 'category_ids', label: 'Categories', type: 'categroup', show_simple: true },
      { key: 'part_no_search', label: 'Part Number', type: 'input', width: 400, show_simple: true, hide_advanced: true },
      { key: 'part_no_is_accurate', label: '精确', type: 'checkbox', show_simple: true, hide_advanced: true },
      { key: 'is_special', label: 'Special', type: 'select', state: 'is_special', width: 100 },
      { key: 'visibility', label: 'Visibility', type: 'select', state: 'visibility', width: 100 },
      { key: 'stock_qty', label: 'Stock Qty >=', type: 'input', width: 80, placeholder: '0' },
      { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'oper_id', label: 'Input', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'part_no_search', label: 'Part Number', type: 'multi', width: 260 },
      { key: 'description', label: 'Description', type: 'multi', width: 260 },
      { key: 'brand', label: 'Brand', type: 'multi', width: 160 },
      { key: 'class_id', label: 'Class', type: 'select', state: 'class', option_value: 'id', option_label: 'name', width: 260 },
      { key: 'mkt', label: 'Information', type: 'multi', width: 260 },
      { key: 'company', label: 'Company', type: 'multi', width: 260 },
      { key: 'oper_time', label: 'Time', type: 'timerange' },
      { key: 'remark', label: 'Remark', type: 'input', width: 120 },
      { key: 'in_cart', label: 'In Current Cart', type: 'checkbox' }
    ]" @search="doSearch"/>

    <div class="card">
      <div flex>
        <div>
          <el-dropdown split-button @click="print(0, '/offer-preview')">
            <i class="el-icon-printer"></i>
            Print
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="print(1, '/offer-preview')">with description</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown split-button @click="excel" style="margin-left:10px;">
            <i class="el-icon-document"></i>
            To Excel
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="excel2">with description</el-dropdown-item>
              <el-dropdown-item @click.native="excel3">with company name</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <template v-if="lastCompany.id">
            <el-button @click="$open('/offer-refer')" style="margin-left:10px;">Show requirement to offer</el-button>
            <el-button @click="openOfferList(lastCompany.name)" style="font-weight:bold;">{{ lastCompany.name }} Offer List</el-button>
            <el-button @click="$open('/offer-refer-detail', 1100)">Show Item Details</el-button>
          </template>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>

      <cate-table :columns="[
        { key: 'part_no', title: 'Part Number' },
        { key: 'description', title: 'Description' },
        { key: 'brand', title: 'Brand' },
        { key: 'display_qty', title: 'Qty' },
        { key: 'display_price', title: 'Price' },
        { key: 'lead_time', title: 'Lead Time' },
        { key: 'd_c', title: 'D/C' },
        { key: 'c_o', title: 'C/O' },
        { key: 'remark', title: 'Remark' }
      ]"
      :data="list"
      :loading="loading"
      show-detail
      show-cart
      show-special
      @detail-click="$open(`/product/${arguments[0]}/details`)"
      @part-click="$open(`/product/${arguments[0]}/offer`)"
      style="margin:10px 0;" />

      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
  </page-container>
</template>

<script>
import TopNav from '@/components/TopNav'
import ListFunc from '@/mixins/ListFunc'
import moment from 'moment'
export default {
  mixins: [ListFunc],
  components: {
    TopNav
  },
  data () {
    return {
      sqlcode: 'offer_list',
      lastCompany: {
        id: 0,
        name: ''
      },
      defaultOperTime: [moment().subtract(3, 'days'), moment().endOf('day')]
    }
  },
  mounted () {
    this.fetchLastCompany()
  },
  methods: {
    doSearch (params) {
      this.search(params)
    },
    fetchLastCompany () {
      this.$http.get('/dbapi/last_offer_company').then(data => {
        if (data.list.length > 0) {
          this.lastCompany = data.list[0]
        }
      })
    },
    openOfferList (company_name) {
      if (company_name) {
        this.search({
          fixed_company: company_name,
          fixed_sales_id: 'all',
          fixed_oper_id: 'all',
          company: company_name,
          lookback: 30
        })
      }
      this.$open('/offer-list')
    },
    windowReturn () {
      this.refresh()
      this.fetchLastCompany()
    }
  }
}
</script>